import { render, staticRenderFns } from "./WelcomeNotice.vue?vue&type=template&id=5f9e82c6&scoped=true"
import script from "./WelcomeNotice.vue?vue&type=script&lang=ts"
export * from "./WelcomeNotice.vue?vue&type=script&lang=ts"
import style0 from "./welcome-notice.component.scss?vue&type=style&index=0&id=5f9e82c6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_babel-core@7.0.0-bridge.0_@babel+core@7.29._c9bb53b0edaa8087f33e181baf8c3b86/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e82c6",
  null
  
)

export default component.exports